module.exports = __webpack_public_path__ + "static/media/starterguide1v2.7cf236b3.png";